/**
 * Inspection (DVI) template management in settings.
 *
 * The shell — heading, create button, show-inactive switch, list, dialog —
 * is shared with the checklist and work-path tabs (#2624). Only the labels
 * differ here: this tab reads `inspectionTemplates.*` from the settings
 * namespace and calls the filter "show hidden" rather than "show inactive".
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TemplateTabLayout } from '../TemplateTabLayout';
import { TemplatesList } from './TemplatesList';
import { TemplateFormDialog } from './TemplateFormDialog';
import type { InspectionTemplate } from '@/hooks/useInspections';

export function InspectionTemplatesTab() {
  const { t } = useTranslation('settings');
  const [editTemplate, setEditTemplate] = useState<InspectionTemplate | null>(null);

  return (
    <TemplateTabLayout
      title={t('inspectionTemplates.title')}
      subtitle={t('inspectionTemplates.subtitle')}
      createLabel={t('inspectionTemplates.createTemplate')}
      showInactiveLabel={t('inspectionTemplates.showHidden')}
      isEditing={editTemplate !== null}
      onCloseDialog={() => setEditTemplate(null)}
      renderList={(includeInactive) => (
        <TemplatesList onEdit={setEditTemplate} includeInactive={includeInactive} />
      )}
      renderDialog={(open, onClose) => (
        <TemplateFormDialog open={open} onClose={onClose} template={editTemplate} />
      )}
    />
  );
}
